import React from 'react';

const BUSYBEE_ICON_SRC = '/icon.svg';

const BusyBeeLogo = ({ className = "h-8 w-8", showText = true, textClassName = "", iconOnly = false }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={BUSYBEE_ICON_SRC}
        alt="BusyBee.Day"
        className="h-full w-auto"
        draggable={false}
      />

      {showText && !iconOnly && (
        <span className={`text-xl tracking-tight ${textClassName || 'text-foreground'}`}>
          <span className="font-bold">Busy</span><span className="font-normal text-amber-700 dark:text-amber-400">Bee.Day</span>
        </span>
      )}
    </div>
  );
};

export const BusyBeeIcon = ({ className = "h-6 w-6" }) => {
  return (
    <img
      src={BUSYBEE_ICON_SRC}
      alt="BusyBee.Day"
      className={className}
      draggable={false}
    />
  );
};

export default BusyBeeLogo;
